import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/mocks/articles';

interface ArticleFeedProps {
  articles: Article[];
}

export default function ArticleFeed({ articles }: ArticleFeedProps) {
  if (articles.length === 0) {
    return (
      <div className="text-center py-16">
        <i className="ri-inbox-line text-5xl text-foreground-300"></i>
        <p className="mt-3 text-foreground-400">暂无相关文章</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {articles.map((article) => (
        <ArticleCard key={article.id} article={article} />
      ))}
    </div>
  );
}